import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { FileService } from './files.service';
import { FileRequest } from './file-request.interface';
const service = new FileService();

export interface FileState {}

const FileStore: Module<FileState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async post(context, file: Partial<FileRequest>) {
         const response = await service.postFile(file);
         return response.data;
      },
      async removeFile(context, { id }: { id: number }) {
         await service.deleteFile(id);
         return;
      },
      async getNewFileUrl(context, id: number) {
         const response = await service.getNewFileUrl(id);
         return response.data;
      },
      async getExternalFileUrl(context, id: number) {
         const response = await service.getExternalFileUrl(id);
         return response.url;
      },
   },
};

export default FileStore;
